import * as signalR from "@microsoft/signalr";
import { toast } from "react-toastify";
import { NOTIFICATION_URL } from '../config';

let connection = null;

// Define triggerNotification outside to ensure it's initialized only once
const triggerNotification = (message) => {
    toast.success(message);
    // You can also use other toast types: toast.info, toast.warning, toast.error, etc.
};
const showBrowserNotification = (title, options) => {
    if (Notification.permission === "granted") {
        new Notification(title, options);
    } else {
        console.log("Notification permission is not granted.");
    }
};

export const startSignalRConnection = () => {

    // Only create the connection if it doesn't already exist
    if (!connection) {
        connection = new signalR.HubConnectionBuilder()
            .withUrl(`${NOTIFICATION_URL}/notificationHub?userId=` + localStorage.getItem("userId"), {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            })
            .configureLogging(signalR.LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        // Listen for messages from the server (this should only happen once)
        connection.on("ReceiveNotification", (message) => {
            debugger;
            console.log("New notification:", message);
            triggerNotification(message); // Call toast notification
            showBrowserNotification(message, {
                body: "You have received a new message.",
                icon: "/path-to-icon.png",
            });

        });
    }

    // Only attempt to start the connection if it's not already connected
    if (connection.state === signalR.HubConnectionState.Disconnected) {
        connection.start().then(() => {
            console.log("SignalR connected");
        }).catch(err => {
            console.error("SignalR connection failed: ", err);
        });
    }

    return connection;
};

export const stopSignalRConnection = async () => {
    if (connection) {
        try {
            await connection.stop();
            console.log("SignalR connection stopped.");
        } catch (err) {
            console.error("Error stopping SignalR connection: ", err);
        }
    }
};

export const getSignalRConnection = () => connection;
